import { render, staticRenderFns } from "./ModelSelectDia.vue?vue&type=template&id=3bbd9f98&scoped=true"
import script from "./ModelSelectDia.vue?vue&type=script&lang=js"
export * from "./ModelSelectDia.vue?vue&type=script&lang=js"
import style0 from "./ModelSelectDia.vue?vue&type=style&index=0&id=3bbd9f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd9f98",
  null
  
)

export default component.exports